module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_05_6DB79_1SB_GLU.fb7d5020.png";